/**
 * Responsibility: read a card's printed number out of its product key.
 *
 * PriceCharting keys end in the card's number - `pokemon-chaos-rising/
 * mega-gallade-ex-48` is card 48 - which is the only per-card ordinal this
 * system holds without a catalogue lookup.
 *
 * **It is a hint, not a fact.** A promo numbered "SM162" has no integer at the
 * end, a card numbered "TG04" has one that means something else, and a slug
 * ending in a year would read as a very high card number. So this returns null
 * whenever it is unsure, and callers may only use it for things that are still
 * honest when some cards are missing from the answer.
 */

/** Trailing digits, which is where the card number sits in a slug. */
const TRAILING_NUMBER = /-(\d{1,4})$/;

/**
 * Card numbers above this are almost certainly not card numbers - a slug
 * ending in a print year, most likely. The largest real sets run to a few
 * hundred including secret rares.
 */
const IMPLAUSIBLE = 1000;

export function cardNumber(productKey: string): number | null {
  const slug = productKey.split('/').pop() ?? '';
  const found = TRAILING_NUMBER.exec(slug);
  if (!found) return null;
  const value = Number(found[1]);
  return value > 0 && value < IMPLAUSIBLE ? value : null;
}
